<!-- MFITTで照会可能時間外に操作した場合 -->
<template>
  <ItemDialog ref="confirmFirstTimeToChangePurchasedTicket" imageType="alert">
    <template v-slot:content-area>
      <p class="text-center">
        日付の変更は1回のみ可能です。このまま続けますか?
      </p>
    </template>
    <template v-slot:button-area>
      <ItemButton label="続ける" actionType="btn-primary" @clicked="goToNextPage()" />
      <ItemButton label="閉じる" actionType="btn-cancel" @clicked="closeDialog()" />
    </template>
  </ItemDialog>
</template>

<script>
import { ref, SetupContext } from "vue";

export default {
  name: "DialogConfirmFirstTimeToChangePurchasedTicket",
  setup(props, context) {
    const confirmFirstTimeToChangePurchasedTicket = ref(null);

    const goToNextPage = () => {
      context.emit("goToNextPage");
    };

    const openDialog = () => {
      confirmFirstTimeToChangePurchasedTicket.value.open();
    };

    const closeDialog = () => {
      confirmFirstTimeToChangePurchasedTicket.value.close();
    };

    return {
      confirmFirstTimeToChangePurchasedTicket,
      goToNextPage,
      openDialog,
      closeDialog,
    };
  },
};
</script>
